import { render, staticRenderFns } from "./UploadFileIcon.vue?vue&type=template&id=2f7adfba"
import script from "./UploadFileIcon.vue?vue&type=script&lang=js"
export * from "./UploadFileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports